module.exports = __webpack_public_path__ + "41b70341463a9606f0008a7ef21ddb7d.svg";